import React from "react";
import S from "../../styles/components";
import PanelContext from "./PanelContext";

class Panel extends React.Component {
  static contextType = PanelContext;

  render() {
    const { children, title, loading, style = {} } = this.props;
    const { stackSize, nextPanel } = this.context;

    return (
      <S.Panel style={style}>
        {!!title && <S.PanelHeader>{title}</S.PanelHeader>}
        <S.PanelBody>{children}</S.PanelBody>
      </S.Panel>
    );
  }
}

export default Panel;
